import { render, staticRenderFns } from "./DemographicsReport.vue?vue&type=template&id=36af944a&scoped=true&"
import script from "./DemographicsReport.vue?vue&type=script&lang=ts&"
export * from "./DemographicsReport.vue?vue&type=script&lang=ts&"
import style0 from "./DemographicsReport.vue?vue&type=style&index=0&id=36af944a&prod&lang=css&"
import style1 from "./DemographicsReport.vue?vue&type=style&index=1&id=36af944a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af944a",
  null
  
)

export default component.exports
import {QPage,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn})
